<template>
  <custom-popup
    v-model="computedValue"
    :cons="
      submitNewPattern
        ? { title: 'انتخاب پترن' }
        : submitNewCampaign
        ? { title: 'انتخاب کمپین' }
        : patternCons
    "
    :hide-confirm="submitNewPattern || submitNewCampaign"
    persistent
  >
    <v-card :loading="patternLoading" class="pa-4" flat>
      <v-expand-transition mode="out-in">
        <div v-if="!submitNewPattern && !submitNewCampaign" key="tabs">
          <v-card-title>
            <v-btn
              v-if="patternTabs !== 1"
              :disabled="submitNewPattern"
              class="ma-0 rounded-lg success"
              dark
              outlined
              @click="submitNewPattern = true"
            >
              <v-icon left>mdi-plus</v-icon>
              ثبت پترن جدید
            </v-btn>

            <v-btn
              v-else
              class="ma-0 rounded-lg success"
              dark
              outlined
              target="_blank"
              @click="handleNewCamp"
            >
              <v-icon left>mdi-plus</v-icon>
              ثبت کمپین جدید
            </v-btn>
          </v-card-title>

          <custom-tabs
            v-model="patternTabs"
            :tab-items="[
              { text: 'پترن شخصی' },
              { text: 'کمپین' },
              { text: 'پترن عمومی' },
            ]"
            :tabs-items-attrs="{ touchless: true }"
            grow
          >
            <template v-slot:staticItems>
              <v-tab-item>
                <vue-table
                  v-model="selectedRow"
                  :data="patternData"
                  :headers="patternHeaders"
                  show-select
                  single-select
                  @change="onPatternPagination"
                  @click:row="clickRow"
                >
                  <template v-slot:type="{ item }">
                    {{ item.type === "normal" ? "الگو" : "پترن" }}
                  </template>

                  <template v-slot:state="{ item }">
                    <v-chip
                      :color="sateText(item.state).color"
                      small
                      v-text="sateText(item.state).text"
                    />
                  </template>
                </vue-table>
              </v-tab-item>

              <v-tab-item>
                <vue-table
                  v-model="selectedRow"
                  :data="patternData"
                  :headers="patternHeaders"
                  show-select
                  single-select
                  @change="onPatternPagination"
                  @click:row="clickRow"
                >
                  <template v-slot:count="{ item }">
                    {{ item.messages.text.length }}
                  </template>

                  <template v-slot:messages.count="{ item }">
                    {{ item.messages.count || "-" }}
                  </template>

                  <template v-slot:messages.name="{ item }">
                    {{ item.messages.name || "-" }}
                  </template>

                  <template v-slot:status="{ item }">
                    <v-chip
                      :color="sateText(item.status).color"
                      small
                      v-text="sateText(item.status).text"
                    />
                  </template>
                </vue-table>
              </v-tab-item>
              <v-tab-item>
                <vue-table
                  v-model="selectedRow"
                  :data="patternData"
                  :headers="patternHeaders"
                  show-select
                  single-select
                  @change="onPatternPaginationGlobal"
                  @click:row="clickRow"
                >
                  <template v-slot:type="{ item }">
                    {{ item.type === "normal" ? "الگو" : "پترن" }}
                  </template>

                  <template v-slot:state="{ item }">
                    <v-chip
                      :color="sateText(item.state).color"
                      small
                      v-text="sateText(item.state).text"
                    />
                  </template>
                </vue-table>
              </v-tab-item>
            </template>
          </custom-tabs>
        </div>

        <div v-else-if="submitNewPattern" key="box">
          <v-card-title
            v-if="
              !!patternData && !!patternData.data && !!patternData.data.length
            "
            class="justify-end"
          >
            <v-btn
              class="ma-0 rounded-lg btn-back"
              depressed
              @click="submitNewPattern = false"
            >
              <v-icon left>mdi-close</v-icon>
              بازگشت
            </v-btn>
          </v-card-title>

          <v-row justify="center" no-gutters>
            <v-col class="pa-2" cols="12" lg="8" md="10">
              <v-text-field
                v-model="patternTitle"
                :rules="rules.empty"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="عنوان"
                outlined
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="8" md="10">
              <suggest-input-pattern
                v-model="patternText"
                :rules="rules.text"
                label="متن"
              />
            </v-col>
          </v-row>

          <v-card-actions class="justify-end">
            <v-btn
              :disabled="!canMore"
              :loading="patternLoading"
              class="btn-accept rounded-lg"
              depressed
              min-width="120"
              @click="submit"
            >
              <v-icon left>mdi-check</v-icon>
              ثبت پترن
            </v-btn>
          </v-card-actions>
        </div>

        <div v-else-if="submitNewCampaign" key="campaing">
          <v-card-title
            v-if="
              !!patternData && !!patternData.data && !!patternData.data.length
            "
            class="justify-end"
          >
            <v-btn
              class="ma-0 rounded-lg btn-back"
              depressed
              @click="submitNewCampaign = false"
            >
              <v-icon left>mdi-close</v-icon>
              بازگشت
            </v-btn>
          </v-card-title>

          <create-campaign ref="create-camp" @fetch="newCampaign" />
        </div>
      </v-expand-transition>
    </v-card>
  </custom-popup>
</template>

<script>
import suggestInputPattern from "@/view/content/sms/suggestInput/suggestInputPattern.vue";
import CreateCampaign from "@/view/content/pickers/campaign/createCampaign.vue";
import axios from "axios";

export default {
  name: "saveSteps",

  components: { CreateCampaign, suggestInputPattern },

  props: {
    value: Boolean,
    selected: Array,
  },

  data() {
    return {
      computedValueCampaign: {},
      dialog: false,
      callLoading: false,
      patternHeaders: [],
      patternData: [],
      submitNewPattern: false,
      submitNewCampaign: false,
      patternProps: {
        length: 10,
        page: 1,
        dir: "desc",
        status: "private",
        active: 1,
        default: 1,
      },
      patternPropsGlobal: {
        length: 10,
        page: 1,
        dir: "desc",
      },
      patternLoading: false,
      patternTabs: 0,
      patternCons: {
        title: "انتخاب پترن/کمپین",
      },
      patternTitle: "",
      patternText: "\nلغو11",
      userInfoItems: [
        { value: "preName", text: "پیشوند" },
        { value: "name", text: "نام" },
        { value: "middleName", text: "نام میانی" },
        { value: "lastName", text: "نام خانوادگی" },
        { value: "postName", text: "پسوند" },
        { value: "alias", text: "نام مستعار" },
        { value: "companyName", text: "شرکت" },
        { value: "jobTitle", text: "عنوان شغلی" },
        { value: "phone", text: "شماره تلفن" },
        { value: "birthday", text: "تاریخ تولد" },
        { value: "description", text: "توضیحات" },
      ],
      rules: {
        text: [
          (n) => !!n || this.$t("ERRORS.EmptyText"),
          (n) => n.includes("لغو11") || "متن بایستی شامل عبارت لغو11 باشد",
        ],
        empty: [(n) => (!!n && n.length > 2) || "فیلد نمی‌تواند خالی باشد."],
        line: [(n) => !!n || this.$t("ERRORS.NoSelectedLineNumber")],
        link: [(n) => this.isDomain(n) || "لینک صحیح وارد نمایید"],
      },
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedRow: {
      get() {
        return this.selected;
      },
      set(val) {
        this.$emit("update:selected", val);
      },
    },
    canMore() {
      return (
        !!this.patternText.replace("\nلغو11", "") &&
        this.patternText.includes("لغو11")
      );
    },
  },

  watch: {
    value(val) {
      val && this.getPatternList();
    },
    patternTabs(val) {
      this.patternProps = {
        length: 10,
        page: 1,
        dir: "desc",
        status: val === 0 ? "private" : val === 2 ? "public" : "accept",
      };
      this.patternPropsGlobal = {
        length: 10,
        page: 1,
        dir: "desc",
      };
      this.$nextTick(() => {
        this.getPatternList();
      });
    },
    submitNewPattern(val) {
      if (!val) {
        this.patternData = { data: [] };
        this.getPatternList();
      }
    },
    submitNewCampaign(val) {
      if (!val) {
        this.patternData = { data: [] };
        this.getPatternList();
        this.patternTabs = 1;
      }
    },
  },

  methods: {
    getDefaultPattern() {
      this.loading = true;
      this.requestApiGetPayamak("text/get/default")
        .then(({ data }) => this.selectedRow.push(data.data))
        .catch(({ response }) => {
          console.log("failed to get default pattern: ", response);
        })
        .finally(() => (this.loading = false));
    },
    getPatternList(params = this.patternProps) {
      this.patternLoading = true;
      let endpoint = this.patternTabs === 1 ? "campaign/list" : "text";
      if (!this.patternTabs) {
        this.requestApiGetPayamak("text", {
          length: 10,
          page: 1,
          dir: "desc",
          status: "private",
          active: 1,
          default: 1,
          state: "accept",
          ...params,
        })
          .then(({ data }) => {
            this.patternHeaders = [
              { value: "id", text: "شناسه", sortable: false },
              { value: "type", text: "نوع", sortable: false },
              { value: "title", text: "عنوان", sortable: false },
              { value: "content", text: "متن", sortable: false },
              { value: "state", text: "وضعیت", sortable: false },
            ];

            if (!data?.data?.length) {
              this.submitNewPattern = true;
              this.patternText =
                "از تماس شما با مجموعه ما سپاسگزاریم\n" +
                "با ما درتماس باشید\n" +
                "02191017077\n" +
                "لغو11";
              this.patternTitle = "پیام خوش آمدگویی";
              return;
            }

            this.$nextTick(() => {
              this.patternData = {
                data: data.data,
                ...data.links,
                ...data.meta,
              };
              this.items = data.data.map((item) => ({
                id: item.id,
                text: item.text || "",
                messages: item.messages || { text: "" },
                campId: item.campId || item.id,
              }));
            });
          })
          .finally(() => (this.patternLoading = false));
      } else if (this.patternTabs === 2) {
        this.requestApiGetPayamak("text", {
          length: 10,
          page: 1,
          dir: "desc",
          status: "public",
          active: 1,
          state: "accept",
          ...this.patternPropsGlobal,
        })
          .then(({ data }) => {
            this.patternHeaders = [
              { value: "id", text: "شناسه", sortable: false },
              { value: "type", text: "نوع", sortable: false },
              { value: "title", text: "عنوان", sortable: false },
              { value: "content", text: "متن", sortable: false },
              { value: "state", text: "وضعیت", sortable: false },
            ];

            if (!data?.data?.length) {
              this.submitNewPattern = true;
              this.patternText =
                "از تماس شما با مجموعه ما سپاسگزاریم\n" +
                "با ما درتماس باشید\n" +
                "02191017077\n" +
                "لغو11";
              this.patternTitle = "پیام خوش آمدگویی";
              return;
            }

            this.$nextTick(() => {
              this.patternData = {
                data: data.data,
                ...data.links,
                ...data.meta,
              };
            });
          })
          .finally(() => (this.patternLoading = false));
      } else if (this.patternTabs === 1) {
        this.requestApiGetPayamak("campaign/list", {
          active: 1,
          status: "accept",
          state: "accept",
          ...params,
        })
          .then(({ data }) => {
            this.patternHeaders = [
              { value: "id", text: "شناسه", sortable: false },
              { value: "count", text: "تعداد پیام", sortable: false },
              {
                value: "messages.count",
                text: "مجموع پیام (صفحه)",
                sortable: false,
              },
              { value: "messages.name", text: "نام کمپین", sortable: false },
              { value: "status", text: "وضعیت", sortable: false },
            ];

            if (!data?.data?.length) {
              this.submitNewCampaign = true;
              setTimeout(() => {
                this.$refs["create-camp"].mlModel = [
                  {
                    title: "تشکر از تماس",
                    gap: 0,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "🟢از تماس شما\n" +
                      'با "ترمینال تبلیغات" سپاسگزاریم💞\n' +
                      "\n" +
                      "لغو11",
                  },
                  {
                    title: "معرفی ویژگی های کلیدی",
                    gap: 2,
                    type: "hour",
                    lang: "",
                    msgCount: 0,
                    text:
                      "بهترین ها را در یک [محصول/خدمت] گردآوری کرده ایم\n" +
                      "✅\n" +
                      "✅\n" +
                      "✅\n" +
                      "[لینک سایت]\n" +
                      "[شماره تماس]\n" +
                      "لغو11",
                  },
                  {
                    title: "تشویق به خرید با تخفیف",
                    gap: 1,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "برای خرید آسان‌تر از [نام محصول/خدمت]\n" +
                      "تخفیف ویژه [مقدار تخفیف]٪\n" +
                      "فقط برای شما فعال شده.\n" +
                      "حالا خرید کنید:\n" +
                      "[لینک سایت]\n" +
                      "لغو11",
                  },
                  {
                    title: "دعوت به عضویت در شبکه های اجتماعی",
                    gap: 3,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "برای دریافت جدیدترین تخفیفات و پیشنهادات ویژه\n" +
                      "در شبکه اجتماعی ما عضو شوید\n" +
                      "و همیشه یک قدم جلوتر باشید!\n" +
                      "[لینک کارت ویزیت الکترونیکی]\n" +
                      "لغو11",
                  },
                  {
                    title: "ارتباط با تیم پشتیبانی",
                    gap: 5,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "سلام و وقت بخیر!\n" +
                      "اگر به دنبال [نام خدمت/محصول] هستید\n" +
                      "پیشنهاد ویژه ما [نام محصول یا خدمت] است\n" +
                      "ابتدا بررسی > و سپس خربد کنید\n" +
                      "[لینک سایت]\n" +
                      "لغو11",
                  },
                  {
                    title: "جشنواره فروش ویژه",
                    gap: 1,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "سلام\n" +
                      "اگر هنوز سوالی دارید\n" +
                      "یا نیاز به مشاوره دارید\n" +
                      "تیم پشتیبانی ما در خدمت شماست.\n" +
                      "تماس: [شماره تماس]\n" +
                      "لغو11",
                  },
                  {
                    title: "نظرسنجی کوتاه",
                    gap: 7,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "⭕پیشنهاد ویژه این هفته ما [نام پیشنهاد ویژه]\n" +
                      "فرصت را از دست ندهید و حالا خرید کنید:\n" +
                      "[لینک سایت]\n" +
                      "لغو11",
                  },
                  {
                    title: "نظرسنجی کوتاه",
                    gap: 10,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "نظر شما برای ما ارزشمند است!\n" +
                      "با تکمیل نظرسنجی کوتاه ما\n" +
                      "به بهبود خدمات ما کمک کنید.\n" +
                      "[لینک نظرسنجی]\n" +
                      "لغو11",
                  },
                  {
                    title: "معرفی تفاوت های چشمگیر محصول/خدمت",
                    gap: 3,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "✳️تفاوت را لمس کنید\n" +
                      "🎯با یک تیر سه نشان\n" +
                      "✅\n" +
                      "✅\n" +
                      "✅\n" +
                      "[لینک کارت ویزیت الکترونیکی]\n" +
                      "لغو11",
                  },
                  {
                    title: "هدیه برای خرید اول",
                    gap: 1,
                    type: "day",
                    lang: "",
                    msgCount: 0,
                    text:
                      "سلام و تشکر از وجودتان در مجوعه ما!\n" +
                      "برای خرید اول خود از [نام محصول/سایت] یک هدیه ویژه از ما دریافت کنید.\n" +
                      "همین حالا خرید کنید:\n" +
                      "[لینک سایت]\n" +
                      "لغو11",
                  },
                ];
              }, 500);
              return;
            }

            this.$nextTick(() => {
              this.patternData = data;
            });
          })
          .finally(() => (this.patternLoading = false));
      }
    },
    onPatternPagination(e) {
      let props = {
        ...this.patternProps,
        ...e,
      };
      this.getPatternList(props);
    },
    onPatternPaginationGlobal(e) {
      let props = {
        ...this.patternPropsGlobal,
        ...e,
      };
      this.getPatternList(props);
    },
    clickRow(e) {
      this.selectedRow = [e];
      this.computedValue = false;
    },
    setDefault(close = true) {
      this.patternLoading = true;
      if (!this.selectedRow?.length) {
        setTimeout(() => {
          this.patternLoading = false;
        }, 1000);
        return;
      }
      this.requestApiPostPayamak("text/set/default", {
        type: !!this.patternTabs ? "campaign" : "pattern",
        item_id: this.selectedRow[0].id,
      })
        .then(({ data }) => {
          this.dialog = false;
          if (!close) {
            this.$toast.success("با موفقیت تنظیم شد.");
            this.$emit("reload");
          }
        })
        .finally(() => (this.patternLoading = false));
    },
    handleNewCamp() {
      this.submitNewCampaign = true;
    },
    sateText(state) {
      switch (state) {
        case "accept":
          return {
            text: "تایید شده",
            color: "success",
          };
        case "pending":
          return {
            text: "منتظر تایید",
            color: "warning",
          };
        case "reject":
          return {
            text: "رد شده",
            color: "red",
          };
      }
    },
    submit() {
      this.patternLoading = true;

      const userInfoValues = this.userInfoItems.map((item) => item.text);
      const regex = new RegExp(`{(${userInfoValues.join("|")}|\\w+)}`, "g");
      const matches = [...new Set(this.patternText.match(regex) || [])];

      const invalidFields = matches.filter((match) => {
        const value = match.slice(1, -1);
        return !userInfoValues.includes(value);
      });
      if (invalidFields.length > 0) {
        this.$toast.error(
          `مشخصات نامعتبر یافت شد: ${invalidFields.join(", ")}`,
        );
        this.patternLoading = false;
        return;
      }
      const fields = matches.map((match, index) => ({
        text: `data${index + 1}`,
        state: "userInfo",
        value: match.slice(1, -1),
      }));

      let apiText = this.patternText;
      fields.forEach((field, index) => {
        apiText = apiText.replace(
          new RegExp(`{${field.value}}`, "g"),
          field.text,
        );
      });
      const desc = {
        // title: this.patternTitle,
        // fields: fields,
        fields,
      };
      console.log("desc: ", JSON.stringify(desc));
      console.log("apiText: ", apiText);
      axios
        .post(`${this.$payamakApi}/text/create`, {
          content: apiText,
          title: this.patternTitle,
          desc: this.patternTitle,
          meta: JSON.stringify(desc),
          phone_id: 112,
          type: fields?.length > 0 ? "pattern" : "normal",
        })
        .then(({ data }) => {
          this.patternTabs = 0;
          this.submitNewPattern = false;
          // this.clickRow({
          //   id: data.data.MsgId,
          //   title: this.patternTitle,
          //   desc: JSON.stringify(desc),
          //   content: apiText,
          //   phone_id: 59,
          // });
          this.$nextTick(() => {
            this.getPatternList();
          });
        })
        .catch(({ response }) => {
          console.log("failed to create pattern: ", response);
          this.$toast.error("خطا در ثبت پترن");
        })
        .finally(() => (this.patternLoading = false));
    },
    newCampaign(item) {
      this.submitNewCampaign = false;
      this.patternTabs = 1;
      this.getPatternList();
      // this.clickRow(item);
    },
  },
};
//
</script>

<style scoped></style>
